import home from './en/home'
import binocular from './en/binocular'
import eight from './en/eight'
import about from './en/about'
import coreTech from './en/coreTech'
import purchase from './en/purchase'
import purchasetow from './en/purchasetow'
import purchasezhijia from './en/purchasezhijia'
import agent from './en/agent'
import toast from './en/toast'
import manage from './en/manage'

export default {
  title: 'English',
  crumbs: [{
    id: 'pro',
    name: '4DKanKan Pro'
  }, {
    id: 'lite',
    name: '4DKanKan Lite'
  }],
  navs: {
    services: 'Services',
    application: 'Applications',
    setting: {
      'purchase': [
        {
          icon: 'icon-icon_cam_pro',
          name: '4DKanKan Pro<br/>&nbsp;',
          new: true,
          to: {name: 'purchase'}
        },
        // {
        //   icon: 'icon-icon_cam_lite',
        //   name: '4DKanKan Lite<br/>&nbsp;',
        //   to: {name: 'binocular'}
        // },
        {
          icon: 'icon-icon_cam_zengzhi',
          name: 'Cloud<br/>Capacity',
          to: {name: 'pricedetail'}
        },
        {
          icon: 'icon-icon_cam_fitting',
          name: '4DKanKan Pro Tripot Set',
          to: {name: 'purchasezhijia'}
        },
        {
          icon: 'icon-jingxiaoshang',
          name: 'Be Our Distributor',
          to: {name: 'agent'}
        }

      ],
      'service_overview': [
        {
          icon: 'icon-appdown',
          name: 'App <br/>Download',
          to: {name: 'service_list', params: {id: 'app', active: 'pro'}}
        },
        {
          icon: 'icon-tutorial',
          name: 'User <br/>Tutorial',
          to: {name: 'service_list', params: {id: 'use', active: 'pro'}}
        },
        {
          icon: 'icon-faq',
          name: 'FAQ<br/>&nbsp;',
          to: {name: 'service_list', params: {id: 'qa', active: 'pro'}}
        },
        // {
        //   icon: 'icon-sysc',
        //   name: '产品手册',
        //   to: {name: 'service_list', params: {id: 'product', active: 'all'}}
        // },
        {
          icon: 'icon-baoxiutiaokuan',
          name: 'Warranty <br/>Information',
          to: {name: 'service_list', params: {id: 'clause', active: 'pro'}}
        },
        {
          icon: 'icon-teaching',
          name: 'Video <br/>tutorial',
          to: {name: 'video-course'}
        }
      ],
      'case_overview': [
        {
          icon: 'icon-industry_realty',
          name: 'Real estate',
          to: {name: 'cases', params: {id: '房地产'}}
        }, {
          icon: 'icon-industry_museum',
          name: 'Museum',
          to: {name: 'cases', params: {id: '博物馆'}}
        },
        {
          icon: 'icon-industry_ecom',
          name: 'E-commerce',
          to: {name: 'cases', params: {id: '电商'}}
        },
        {
          icon: 'icon-industry_home',
          name: 'Home',
          to: {name: 'cases', params: {id: '家居'}}
        },
        {
          icon: 'icon-industry_catering',
          name: 'Catering',
          to: {name: 'cases', params: {id: '餐饮'}}
        },
        {
          icon: 'icon-industry_industry',
          name: 'Others',
          to: {name: 'cases', params: {id: '其他'}}
        },
        {
          icon: 'icon-industry_all',
          name: 'All',
          to: {name: 'cases', params: {id: '全部'}}
        }
      ]
    }
  },
  headers: {
    navs: [
      {text: 'Products', cp: 'purchase'},
      {text: 'Applications', cp: 'case_overview'},
      {text: 'Services', cp: 'service_overview'},
      {text: 'Technologies', cp: 'location'},
      {text: 'About us', cp: 'about'}
    ],
    login: 'Login',
    cart: 'Buy it on Alibaba',
    myaccount: 'My Account',
    logout: 'Log out'
  },
  cases: {
    sceneSelected: {
      '筛选设备': 'Select',
      '全部': 'All',
      '四维看看 Lite': '4DKanKan Lite',
      '四维看看 Pro': '4DKanKan Pro'
    },
    selectType: [
      {
        id: '全部',
        name: 'All'
      },
      {
        id: '四维看看 Lite',
        name: '4DKanKan Lite'
      },
      {
        id: '四维看看 Pro',
        name: '4DKanKan Pro'
      }
    ],
    sort: {
      name: 'sequence',
      items: [
        {
          id: 1,
          name: 'Recommend'
        },
        {
          id: 2,
          name: 'Newest'
        },
        {
          id: 3,
          name: 'Hot'
        }
      ]
    },
    typeName: {
      '房地产': 'Real estate',
      '博物馆': 'Museum',
      '家居': 'Home',
      '餐饮': 'Catering',
      '其他': 'Others',
      '电商': 'E-commerce',
      '全部': 'All'
    },
    typeArr: {
      'Real estate': 2,
      'Museum': 1,
      'Home': 5,
      'Catering': 4,
      'E-commerce': 3,
      'Others': 0,
      'All': null
    }
  },
  search: {
    placeholder: 'Please enter keywords to search'
  },
  footer: {
    fdage: '4DAGE',
    cgaii: 'CGAII',
    model: '4DModel',
    arr: [
      {
        key: 'Business Collaboration',
        val: 'sales@4dage.com'
      }, {
        key: 'Media Inquiries',
        val: 'pr@4dage.com'
      }, {
        key: 'Tel',
        val: '0086 756-6996790-800'
      }
    ]
  },
  kefu: {
    wechat: 'Follow 4DKanKan on Wechat',
    arr: [
      {
        key: 'Business Collaboration',
        val: 'sales@4dage.com'
      }, {
        key: 'Media Inquiries',
        val: 'pr@4dage.com'
      }, {
        key: 'Tel',
        val: '0086 756-6996790-800'
      }, {
        key: 'Working Hours',
        val: 'From Monday to Friday, 09:00 - 12:30, 14:00 - 18:30 (GMT+8)'
      }
    ]
  },
  chat: {
    title: 'Contact us！<br/>Write to us and we\'ll get back to you shortly.',
    p1: 'Enter your email or number',
    p2: 'Enter your number',
    p3: 'Enter your message',
    send: 'send'
  },
  paypage: {
    name: 'Username: ',
    paycenter: 'Pay center',
    method: 'Payment method: ',
    ali: 'Alipay',
    wechatpay: 'Wechat',
    amount: 'Payables: ',
    use1: 'Scan the ',
    use2: ' code and pay'
  },
  _404: {
    txt: 'Error，Please reload.',
    btn: 'Go Back'
  },
  videoCourse: {
    content: [
      {
        name: '视频教程',
        sub: '快速上手以及详细教学',
        items: [
          {
            code: 'img_guide01@2x',
            name: '快速上手指南'
          },
          {
            code: 'img_guide02@2x',
            name: '完整版操作指南'
          }
        ]
      },
      {
        name: '分段教学',
        sub: '功能模块拆解分段学习',
        items: [
          {
            code: 'img_01getready@2x',
            name: '使用前准备'
          },
          {
            code: 'img_03shotstep@2x',
            name: '拍摄流程'
          },
          {
            code: 'img_08shotmode@2x',
            name: '拍摄方式'
          },
          {
            code: 'img_05point@2x',
            name: '点位调整功能'
          },
          {
            code: 'img_06video@2x',
            name: '球幕视频功能'
          },
          {
            code: 'img_02editmb@2x',
            name: '编辑模型-手机APP端模型编辑'
          },
          {
            code: 'img_04editpc@2x',
            name: '编辑模型-PC端模型编辑'
          },
          {
            code: 'img_07share@2x',
            name: '上传分享'
          }
        ]
      }
    ]
  },
  home,
  binocular,
  eight,
  about,
  purchase,
  coreTech,
  purchasetow,
  purchasezhijia,
  manage,
  agent,
  toast
}



// WEBPACK FOOTER //
// ./src/store/language/home_en.js